import { Component, ViewChild, ElementRef, EventEmitter, Output, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, Validators, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import { Subject, take } from 'rxjs';

import { AuthService } from '../../../auth.service';
import { LoaderService } from '../../../loader.service';

import { HeaderComponent } from '../../../header/header.component';
import { ProgressBarComponent } from '../../../shared/progress-bar/progress-bar.component';
import { GoBackButtonComponent } from '../../../shared/go-back-button/go-back-button.component';
import { ErrorDialogComponent } from '../../../dialog/error-dialog/error-dialog.component';
import { LoaderComponent } from '../../../shared/loader/loader.component';
import { BirthdateInputComponent } from '../../../shared/birthdate-input/birthdate-input.component';

import { User } from '../../../shared/interfaces/user';
import { Gender } from '../../../shared/enum/Gender';

import { ClickAnywhereDirective } from '../../../click-anywhere.directive';
import { dateValidator } from '../../../shared/validators/dateValidator';

@Component({
  selector: 'app-auth-subscribe-first',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule, 
    HeaderComponent, 
    RouterOutlet, 
    RouterModule, 
    ProgressBarComponent, 
    GoBackButtonComponent,
    ErrorDialogComponent,
    LoaderComponent,
    MatIconModule,
    BirthdateInputComponent,
    ClickAnywhereDirective
  ],
  templateUrl: './auth-subscribe-first.component.html',
  styleUrls: ['./auth-subscribe-first.component.scss'],
})
export class AuthSubscribeFirstComponent implements OnInit, OnDestroy {
  @Output() emitStepOpenDialog = new EventEmitter<boolean>()
  @ViewChild('userPhoto') userPhoto!: ElementRef
  
  // userBilledInfos = {
  //   operationid: null,
  //   productid: null,
  //   subscription_token: null,
  //   transactionid: null,
  //   userdveid: null,
  // }
  //userBilled = false;
  //inputFocused: string | null = null
  //inputs = { email: null, msisdn: null, password: null }

  loading$ = this.loaderService.loading$
  displayCreatingLoader = false
  hightlightedSteps: {
    first: boolean, 
    second?: boolean, 
    third?: boolean, 
    fourth?: boolean
  } = { first: true }
  error = false
  CGU = false
  user!: User
  subFirstFormGroup!: FormGroup
  errorTitle: string = ''
  errorMessage: string = ''
  private readonly _destroyed = new Subject<void>()
  dateError = false
  day = ''
  month = ''
  year = ''

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {}

  ngOnInit(){
    // retrieve info from the local storage if available
    let birthdate = this.authService.subscriptionFormData.get('birthdate') as string || this.authService.get('birthdate')
    
    this.day = birthdate.substring(8)
    this.month = birthdate.substring(5,7)
    this.year = birthdate.substring(0,4)

    this.subFirstFormGroup = new FormGroup({
      genderCtrl: new FormControl<string>(Gender.man, [Validators.required]), 
      birthdayDateCtrl: new FormGroup({
        birthDayCtrl: new FormControl(this.day || '', [Validators.required]),
        birthMonthCtrl: new FormControl(this.month || '', [Validators.required]),
        birthYearCtrl: new FormControl(this.year || '', [Validators.required]),
      }, {validators: dateValidator()})
    })

    // get auto-generated data from the back to pre-fill the form
    this.authService.getGenericUserData().pipe(take(1)).subscribe(data => {
      if(data.birthdate) {
        birthdate = data.birthdate
      
        this.day = birthdate.substring(8)
        this.month = birthdate.substring(5,7)
        this.year = birthdate.substring(0,4)

        this.subFirstFormGroup.controls['birthdayDateCtrl'].setValue({
          birthDayCtrl: this.day,
          birthMonthCtrl: this.month,
          birthYearCtrl: this.year
        })
      }
    })

    this.subFirstFormGroup.get('birthdayDateCtrl')?.statusChanges.subscribe(() => {
      if(!this.subFirstFormGroup.get('birthdayDateCtrl')?.errors) {
        //console.log('pas d erreur')
        this.dateError = false
      }

      if(this.subFirstFormGroup.get('birthdayDateCtrl')?.errors?.['underAged']){
        this.dateError = true
        this.errorTitle = $localize `:Title of the error dialog when birthdate was less than 18 years ago@@SORRY:Sorry`,
        this.errorMessage = $localize `:Description of the error dialog when birthdate was less than 18 years ago@@UNDERAGE:You must be over 18 years old to subscribe`
      }

      if(this.subFirstFormGroup.get('birthdayDateCtrl')?.errors?.['invalidDate']){
        this.dateError = true
        this.errorTitle = $localize `:Title of the error dialog when birthdate is invalid@@INVALID_DATE:Invalid date`,
        this.errorMessage = $localize `:Description of the error dialog when birthdate is invalid@@DATE_DOES_NOT_EXIST:Given date does not exist. Please check your data and try again.`
      }
    })
  }

  getClickNature(clickNature: string){
    if(clickNature === 'anywhere'){
      this.dateError = false
    }
  }

  onSubmit() {
    const data = this.subFirstFormGroup.value

    // birthdate format: 2005-12-08
    const birthdayDateValue = this.subFirstFormGroup.get('birthdayDateCtrl')?.value
    const dateString = `${birthdayDateValue.birthYearCtrl}-${birthdayDateValue.birthMonthCtrl}-${birthdayDateValue.birthDayCtrl}`
   
    this.authService.setSubscriptionFormData('sex', data.genderCtrl)
    this.authService.setSubscriptionFormData('birthdate', dateString)
    this.authService.set('sex', data.genderCtrl)
    this.authService.set('birthdate', dateString)

    this.router.navigate(['/subscribe-step-two'], { relativeTo: this.route })
  }

  changeCGU() {
    this.CGU = !this.CGU;
  }
  
  setBlurFocusInput() {}

  ngOnDestroy(){
    this._destroyed.next()
    this._destroyed.complete()
  }
}
